import { WebPlugin } from '@capacitor/core';
export class AlarmWeb extends WebPlugin {
    async setAlarm(options) {
        console.log('setAlarm', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async checkPermissions() {
        console.log('checkPermissions');
        throw this.unimplemented('Not implemented on web.');
    }
    async requestPermissions() {
        console.log('requestPermissions');
        throw this.unimplemented('Not implemented on web.');
    }
    async requestFullScreenIntentPermission() {
        console.log('requestFullScreenIntentPermission');
        throw this.unimplemented('Not implemented on web.');
    }
    async stopAlarm(options) {
        console.log('stopAlarm', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async stopAll() {
        throw this.unimplemented('Not implemented on web.');
    }
    async isRinging(options) {
        console.log('isRinging', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async getAlarms() {
        throw this.unimplemented('Not implemented on web.');
    }
    async getRingingAlarms() {
        console.log('getRingingAlarms');
        throw this.unimplemented('Not implemented on web.');
    }
    async setWarningNotificationOnKill(options) {
        console.log('setWarningNotificationOnKill', options);
        throw this.unimplemented('Not implemented on web.');
    }
    async checkAlarm() {
        throw this.unimplemented('Not implemented on web.');
    }
    async addListener(eventName, listenerFunc) {
        return super.addListener(eventName, listenerFunc);
    }
    async removeAllListeners() {
        super.removeAllListeners();
    }
}
//# sourceMappingURL=web.js.map